package io.horion.cv.models

object CountryData {
    val countries = listOf(
        Country(
            image = "cameroun.png",
            cvname = "CV Cameroun",
        ),
        Country(
            image = "canada.png",
            cvname = "CV Canada",
        ),
        Country(
            image = "france.png",
            cvname = "CV France",
        )
    )
}